import { render, staticRenderFns } from "./tabServiceRecord.vue?vue&type=template&id=1d56a865&"
import script from "./tabServiceRecord.vue?vue&type=script&lang=ts&"
export * from "./tabServiceRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports